<template>
  <v-container>
    <v-layout text-center wrap>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card flat>
            <v-card-text>
              <v-tabs
                background-color="white"
                color="deep-purple accent-4"
                left
              >
                <v-tab>Vessels</v-tab>
                <v-tab>Shipping Lines</v-tab>
                <v-tab>Consignees</v-tab>
                <v-tab>Countries</v-tab>
                <v-tab>Departments</v-tab>
                <v-tab>Clinics</v-tab>
                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <vessels-management />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row no-gutters>
                      <shipping-line-data-table />
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="8">
                        <consignees-data-table />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="8">
                        <countries-data-table />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="8">
                        <department-data-table />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="8">
                       clinics here
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import VesselsManagement from "@/components/VesselsManagement";
import ShippingLineDataTable from "@/components/ShippingLineDataTable";
import ConsigneesDataTable from "@/components/ConsigneesDataTable";
import CountriesDataTable from "@/components/CountriesDataTable";
import DepartmentDataTable from "@/components/DepartmentDataTable";

export default {
  components: {
    VesselsManagement,
    ShippingLineDataTable,
    ConsigneesDataTable,
    CountriesDataTable,
    DepartmentDataTable
  }
};
</script>
